<template>
  <div>
    <el-form :inline="true" :model="searchForm">
      <el-form-item label="日期">
        <el-date-picker
          style="width: 250px"
          size="mini"
          v-model="searchForm.createTimeRange"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          :clearable="false"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="getData">查询</el-button>
        <el-button type="primary" size="mini" @click="exportToExcel">导出报表</el-button>
      </el-form-item>
    </el-form>
    <el-table
      max-height="500px"
      :data="tableData"
      style="width: 100%">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="index" label="NO"></el-table-column>
      <el-table-column prop="date" label="日期"></el-table-column>
      <el-table-column prop="company_name" label="单位" width="180"></el-table-column>
      <el-table-column prop="order_num" label="当日总订单"></el-table-column>
      <el-table-column prop="back_num" label="当日驳回订单"></el-table-column>
      <el-table-column prop="pass_num" label="当日通过订单"></el-table-column>
      <el-table-column prop="actual_pay" label="当日成交金额" :formatter="priceMatter"></el-table-column>
      <el-table-column prop="order_num_total" label="累计订单"></el-table-column>
      <el-table-column prop="actual_pay_total" label="累计成交金额" :formatter="priceMatter"></el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.currentPage"
        :page-sizes="[10, 20, 30]"
        :page-size="pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import util from '../utils/utils'
  export default {
    name: "order-count",
    data(){
      const StartAndEnd = util.getMonthStartAndEnd(new Date());
      return{
        searchForm:{
          createTimeRange:[util.dateFormat(StartAndEnd[0]),util.dateFormat(StartAndEnd[1])],
        },
        tableData:[],
        pageInfo:{
          currentPage:1,
          pageSize:20,
          total:0
        }

      }
    },
    created(){
      this.getData()
    },
    methods:{
      getData(){
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0)'
        });
        util.axiosMethods({
          method:"POST",
          url:"api/order/orderCount",
          params:{
            currentPage:this.pageInfo.currentPage,
            pageSize:this.pageInfo.pageSize
          },
          data:{
            startDate:this.searchForm.createTimeRange ? this.searchForm.createTimeRange[0] :"",
            endDate:this.searchForm.createTimeRange ? this.searchForm.createTimeRange[1] :""
          },
          callback:(res => {
            this.tableData = res.data.list
            this.pageInfo.total = res.data.total
            loading.close()
          }),
          catch:(err => {
            loading.close()
          })
        })
      },
      //每页展示数据条数改变
      handleSizeChange(val){
        this.pageInfo.pageSize = val;
        this.getData();
      },
      //页码改变
      handleCurrentChange(val){
        this.pageInfo.currentPage = val;
        this.getData();
      },
      priceMatter(row, column, cellValue, index){
        return cellValue? cellValue.toFixed(2):'0.00'
      },
      //导出
      exportToExcel(){
        const startDate = this.searchForm.createTimeRange ? this.searchForm.createTimeRange[0] :"";
        const endDate = this.searchForm.createTimeRange ? this.searchForm.createTimeRange[1] :"";
        window.open("/api/order/orderCountExportToExcel?startDate="+startDate+"&endDate="+endDate,"_parent");
      },
    }
  }
</script>

<style scoped>
  .block{
    float: right;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/orderCount.vue